<template>
  <div>
    <div>
      <img src="./assets/logo-yatay_300_100.png" style="width: 200px;margin-left:90px " alt="">
    </div>

    <div class="q-pa-md col text-center">
      <h3 style="text-align: center">{{toplamsoru}} üzerinden {{dogrusayisi}} puan aldınız</h3>
      <p  style="text-align: center">Soruları ve cevaplarınızı sayfanın altında bulabilirsiniz.</p>
    </div>
    <div v-if="opts" class="q-pa-md row text-center">
      <h3 style="text-align: center">Size özel ders önerilerimiz.</h3>
    </div>
    <div  v-if="opts" class="row">
      <toefl v-if="optsdata.includes('toefl')"></toefl>
      <ielts v-if="optsdata.includes('ielts')"></ielts>
      <kayitydsyokdil v-if="optsdata.includes('yds')"></kayitydsyokdil>
      <wordup></wordup>
      <okumastratejileri></okumastratejileri>
    </div>

      <vue-element-loading background-color="#dcedff" size="128" spinner="bar-fade-scale"
                           color="#FF6700" text="Lütfen bekleyiniz..." :active="show" is-full-screen />
      <div>
        <div style="width: 80vw; margin-left: 10vw">
            <survey v-if="survey !== null" :survey="survey"></survey>
            <footer>Ankara Dil Akademisi @2024</footer>
        </div>
    </div>
    </div>
</template>

<script>
/* eslint-disable no-extra-boolean-cast */
import showdown from 'showdown'
import { StylesManager, Model } from "survey-vue";
import "survey-vue/defaultV2.css";
import * as SurveyCore from "survey-vue";
import * as widgets from "surveyjs-widgets";
StylesManager.applyTheme("defaultV2");
// Survey.cssType = 'modern'
SurveyCore.setLicenseKey(
    'Mjg1OTYyNzItNTMzYi00ZjQ5LTkzYzUtODI3ZTA5ZDAzZTYyOzE9MjAyNC0wOC0wOSwyPTIwMjQtMDgtMDksND0yMDI0LTA4LTA5'
)
let tr = SurveyCore
    .surveyLocalization
    .getLocaleStrings('tr');
// tr.completeText = '1231212321'
tr.noFileChosen = 'Dosya Seçilmedi'
tr.chooseFile = 'Dosya Seç'
tr.chooseFileCaption = 'Dosya Seç'
tr.cleanCaption = 'Temizle'
tr.clearCaption = 'Temizle'
tr.confirmRemoveFile = 'Dosyayı çıkartmak istediğinize emin misiniz?'
SurveyCore
    .surveyLocalization
    .locales["tr"] = tr
var converter = new showdown.Converter()
function doMarkdown (survey, options) {
  // convert the markdown text to html
  var str = converter.makeHtml(options.text)
  if (str.indexOf('<p>') === 0) {
    // remove root paragraphs <p></p>
    str = str.substring(3)
    str = str.substring(0, str.length - 4)
  }
  // set html
  options.html = str
}
// SurveyVue
//     .StylesManager
//     .applyTheme("darkblue");
// import * as widgets from 'surveyjs-widgets'

import {
  getOneAnketResult,
  saveAnketResultJSON,
  saveAnketResultWKisiJSON
} from '../src/statics/axiosfuncs'
import { Serializer } from "survey-vue";
import Wordup from "@/wordup.vue";
import Kayitydsyokdil from "@/kayitydsyokdil.vue";
import Okumastratejileri from "@/okumastratejileri.vue";
import Ielts from "@/ielts.vue";
import Toefl from "@/toefl.vue";
Serializer.addProperty("question", {
  name: "score:number"
});
const correctStr = "   (Doğru)";
const incorrectStr = "   (Yanlış)";
function getTextHtml (text, str, isCorrect) {
  if (text.indexOf(str) < 0)
    return undefined;

  return text.substring(0, text.indexOf(str)) +
      "<span class='" +  (isCorrect ? "correctAnswer" : "incorrectAnswer" ) + "'>" +
      str +
      "</span>";
}

// Adds "Correct" or "Incorrect" to a question title
function changeTitle (q) {
  if (!q || !q.correctAnswer) return;
  console.log("q",q)
  const isCorrect = q.isAnswerCorrect();
  if (!q.prevTitle) {
    q.prevTitle = q.title;
  }
  if (isCorrect === undefined) {
    q.title = q.prevTitle;
  }
  //find correct answer from choices array and set it to the title

  const c = q.choices.find(o => o.id == q.correctAnswer)
  console.log(c.locTextValue.values.tr)
  q.title = (isCorrect ? correctStr + '</br>   ' + q.prevTitle : incorrectStr + ' </br>   ' + q.prevTitle + ' </br>  Doğru Cevap :  '  + c.locTextValue.values.tr +' olmalıydı' );
}
export default {
  name: 'SonucGoster',
  components: {Toefl, Ielts, Okumastratejileri, Kayitydsyokdil, Wordup},
  // components: {
  //   Survey
  // },
  computed: {},
  methods: {
    calculateMaxScore(questions) {
          var maxScore = 0;
          questions.forEach((question) => {
            if (!!question.score) {
              maxScore += question.score;
            }
          });
          return maxScore;
    },
     calculateTotalScore(data) {
      var totalScore = 0;
      var sonucanaliz = {}
      Object.keys(data).forEach((qName) => {
        const question = this.survey.getQuestionByValueName(qName);
        if(question.score){
          if(question.correctAnswer === question.value) {
            sonucanaliz[qName] = 'Doğru'
            totalScore += question.score || 1;
          } else {
            sonucanaliz[qName] = 'Yanlış'
          }
        }
      });
      return {totalScore,sonucanaliz};
    },
    async getAnketDetail () {
      let id = this.$route.params.id
      console.log('id', id)
      const anket = await getOneAnketResult(id)

      if (!anket) {
        this.$router.push('/hata')
      } else {
        if (anket.result === 1 ) {
          console.log(anket)
          let t = this
          // const d = JSON.parse(anket.data.anketJSON)
            this.toplamsoru = anket.data[0].maxScore
            this.dogrusayisi = anket.data[0].totalScore
            const d = anket.anket[0].anketid.anketJSON
            const anketadi = anket.anket[0].anketid.ad
            console.log(anketadi.toLowerCase(),'anketadi')
            if(anketadi.toLowerCase().includes('ielts')){
              t.opts=true
              t.optsdata = 'ielts'
            }
            if(anketadi.toLowerCase().includes('yds')){
              t.opts=true
              t.optsdata = 'yds'
            }
            if(anketadi.toLowerCase().includes('toefl')){
              t.opts=true
              t.optsdata = 'toefl'
            }
            console.log('optsdata', t.optsdata)
            this.survey = new Model(d)
            this.survey.mode = "display";
            this.survey.questionsOnPageMode = "singlePage";
            this.survey.showProgressBar = "off";
            this.survey.data = anket.data[0]
            this.survey.getAllQuestions().forEach(question => changeTitle(question));
          // console.log('survy',this.survey)
            // this.survey.onUploadFiles.add((_, options) => {
            //   let formData = new FormData();
            //   options.files.forEach(file => {
            //     formData.append(file.name, file);
            //   });
            //
            //   fetch("https://api.surveyjs.io/private/Surveys/uploadTempFiles", {
            //     method: "POST",
            //     body: formData
            //   })
            //       .then(response => response.json())
            //       .then(data => {
            //         options.callback("success", options.files.map(file => {
            //           return {
            //             file: file,
            //             content: "https://api.surveyjs.io/private/Surveys/getTempFile?name=" + data[file.name]
            //           };
            //         }));
            //       })
            //       .catch(error => {
            //         console.error("Error: ", error);
            //       });
            // })

          // Uncomment the following lines if you allow respondents to edit their answers
          // and want to display whether an answer is correct or not immediately after it has been given
          // survey.onValueChanged.add((_, options) => {
          //     changeTitle(options.question);
          // });

          this.survey.onTextMarkdown.add((_, options) => {
            const text = options.text;
            let html = getTextHtml(text, correctStr, true);
            if (!html) {
              html = getTextHtml(text, incorrectStr, false);
            }
            if (!!html) {
              // Set an HTML string with the "Correct" or "Incorrect" suffix for display
              options.html = html;
            }
          });
// Add a custom `score` property to survey questions

          this.survey.onCompleting.add((sender) => {
            console.log('onCompleting', sender.data)
            const sonuc = this.calculateTotalScore(sender.data);
            const maxScore = this.calculateMaxScore(sender.getAllQuestions());
            console.log("Total score: " + sonuc.totalScore)
            console.log("Max score: " + maxScore)
            console.log("Sonuc Analiz: ", sonuc.sonucanaliz)
            // Save the scores in survey results
            sender.setValue("maxScore", maxScore);
            sender.setValue("totalScore", sonuc.totalScore);
            sender.setValue("sonucAnaliz", sonuc.sonucanaliz);
          });
            this.survey
                .onServerValidateQuestions.add(async function(survey, options){
                  // '.' kontrolü

                  let k = Object.keys(options.data)
                  const hatalilar = k.filter((v)=>{
                    return v.match(/[^0-9a-z ]/gi);
                  })
                  if (hatalilar.length > 0) {
                    options.errors[k[0]] = "Formda bir hata var, lütfen ilgili birim ile iletişime geçiniz.";
                    console.log(hatalilar)
                  }
                   options.complete();
               })
          this.survey
                .onTextMarkdown
                .add(doMarkdown)
            this.survey
                  .onComplete
                .add(async function (options) {
                  t.show = true
                  let r = null
                  if (anket.data.dosyadanKayit === true && t.$route.params.kisiid) {
                    r = await saveAnketResultWKisiJSON(t.$route.params.kisaurl, t.$route.params.kisiid, options.data)
                  } else {
                    r = await saveAnketResultJSON(t.$route.params.kisaurl,   options.data)
                  }
                  t.show = false
                  if (r.result === 0 ) {
                    t.$router.push({name: 'hata', params: {hata:'Bu anket Kaydedilemedi. Bir sistem arızası veya anketi daha önce doldurmuş olmanız buna sebep olmuş olabilir!' }})
                  }
                });
        } else {
          this.$router.push({name: 'hata', params: {hata:anket.err }})
        }
      }
      // this.$q.loading.hide()
    }
  },
  data () {
    widgets.select2(SurveyCore);
    widgets.select2tagbox(SurveyCore);
    widgets.inputmask(SurveyCore);
    widgets.jquerybarrating(SurveyCore);
    widgets.jqueryuidatepicker(SurveyCore);
    widgets.nouislider(SurveyCore);
    widgets.sortablejs(SurveyCore);
    widgets.ckeditor(SurveyCore);
    widgets.autocomplete(SurveyCore);
    widgets.bootstrapslider(SurveyCore);
    return {
      survey: null,
      show:false,
      opts:this.$route.params.opts?true:false,
      toplamsoru: this.$route.params.toplamsoru || 0,
      dogrusayisi: this.$route.params.dogrusayisi || 0,
      // optsdata: this.$route.params.opts,
    }
  },

  mounted () {
    if (this.$route.params.id || this.$route.params.id !== '') {
      this.getAnketDetail(this.$route.params.id)
    } else {
      this.$router.push('/hata')
    }
  }
}
</script>
<style>
input[type="file"] {
  display: none;
}
@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');
*
{
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}


body
{
  font-family: 'Roboto', sans-serif;
}
a
{
  text-decoration: none;
}
.product-card {
  width: 380px;
  position: relative;
  box-shadow: 0 2px 7px #dfdfdf;
  margin: 50px auto;
  background: #fafafa;
  box-sizing: border-box;
}

.badge {
  position: absolute;
  left: 0;
  top: 20px;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  background: red;
  color: #fff;
  padding: 3px 10px;
}

.product-tumb {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  padding: 50px;
  background: #f0f0f0;
}

.product-tumb img {
  max-width: 100%;
  max-height: 100%;
}

.product-details {
  padding: 30px;
}

.product-catagory {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #ccc;
  margin-bottom: 18px;
}

.product-details h4 a {
  font-weight: 500;
  display: block;
  margin-bottom: 18px;
  text-transform: uppercase;
  color: #363636;
  text-decoration: none;
  transition: 0.3s;
}

.product-details h4 a:hover {
  color: #fbb72c;
}

.product-details p {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 18px;
  color: #999;
}

.product-bottom-details {
  overflow: hidden;
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.product-bottom-details div {
  float: left;
  width: 50%;
}

.product-price {
  font-size: 18px;
  color: #fbb72c;
  font-weight: 600;
}

.product-price small {
  font-size: 80%;
  font-weight: 400;
  text-decoration: line-through;
  display: inline-block;
  margin-right: 5px;
}

.product-links {
  text-align: right;
}

.product-links a {
  display: inline-block;
  margin-left: 5px;
  color: #e1e1e1;
  transition: 0.3s;
  font-size: 17px;
}

.product-links a:hover {
  color: #fbb72c;
}
.row {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap to the next line if the container's width is exceeded */
  justify-content: space-around; /* Distributes space around items for even spacing. You can adjust this as needed */
  align-items: stretch; /* Adjusts items' height to match the tallest item */
}
</style>
